
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { supabase } from './integrations/supabase/client'
import { AppWithSecurity } from '@/components/App'

// Make the Supabase client available globally for legacy code
window.supabaseClient = supabase;

// Note: runStripeWebhookTest is registered in webhookTestUtils.ts to avoid conflicts

// Add the TypeScript interface for the global properties
declare global {
  interface Window {
    supabaseClient: typeof supabase;
    runStripeWebhookTest: () => Promise<any>;
  }
}

createRoot(document.getElementById("root")!).render(
  <AppWithSecurity>
    <App />
  </AppWithSecurity>
);
